// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"lp-z","badgeLink":"mp-z","category":"np-z"};